import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Invoice } from '../../../models/invoice';
import * as moment from 'moment';
import {InvoicesService} from '../../services/invoices.service';

@Component({
	selector: 'app-invoice-week-table',
	templateUrl: 'invoice-week-table.template.html'
})

/**
 * Component that displays a table of selectable weeks for a collection of invoices
 */
export class InvoiceWeekTableComponent
{
  _invoices_count: WeekInvoices[] = [];
  currentWeek: number = moment().isoWeek();

	get invoices_count(): WeekInvoices[]
  {
    return this._invoices_count;
  }

	@Input()
  set invoices_count(invoices_count: WeekInvoices[])
  {
    this._invoices_count = invoices_count;
  }


	/**
	 * Event that fires when a week has been selected. Contains the selected week's number
	 *
	 * @type {EventEmitter<number>}
	 */
	@Output() onWeekSelect = new EventEmitter<number>();

	/**
	 * Selects new week. Fires onWeekSelect event.
	 *
	 * @param {WeekInvoices} invoice_count
	 *
	 * @returns void
	 */
	selectWeek(invoice_count: WeekInvoices)
	{
		this.onWeekSelect.emit(invoice_count.week_number);
	}
}

/**
 * Class weekInvoices contains data concerning invoice counts for a week
 */
export class WeekInvoices
{
	week_number: number;
	invoice_count: number;
	not_sent_count: number;
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-week-selector/invoice-week-table/invoice-week-table.component.ts